// extracted by mini-css-extract-plugin
export default {"link":"p05Wg","date":"vHx_E","info":"o7kM1"};